import React from 'react';
import { RefreshCw, Cpu } from 'lucide-react';

const PCEHeader = ({ onRefresh }) => {
    return (
        <div className="bg-white rounded-lg shadow-sm p-4 space-y-4">
            {/* Section Titre */}
            <div className="flex justify-between items-start">
                <div>
                    <h2 className="text-lg font-bold text-gray-900">Mes Points de Comptage et d'Estimation</h2>
                    <p className="text-gray-600 text-sm mt-0.5">
                        Consultez vos PCE et visualisez vos données de consommation gaz.
                    </p>
                </div>
                <button
                    onClick={onRefresh}
                    className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-md text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors shrink-0"
                >
                    <RefreshCw className="w-3 h-3 mr-1.5" />
                    Actualiser
                </button>
            </div>
        </div>
    );
};

export default PCEHeader;
